import React from "react"
import { AccordionPanel, Box, Flex } from "@chakra-ui/react"

import { useContentResolver } from "@app/hooks/useContentResolver"

type Props = {
  item: GatsbyTypes.SanityAccordion
  style: string
}

const AccordionGroupItem: React.FC<Props> = ({ item, style }) => {
  const { resolvedContent } = useContentResolver(item?.answer)

  const isProduct = style == "product"
  const isSkinSupport = style === "skin-support" || true

  return (
    <AccordionPanel
      px={{ base: isSkinSupport ? "20px" : 0, sm: "20px" }}
      pt={0}
      pb={isProduct ? { base: "20px", sm: 0 } : 0}
      display={isProduct ? "flex" : "block"}
      justifyContent="flex-end"
    >
      <Flex
        justifyContent="flex-end"
        mt={isProduct ? "-12px" : 0}
        maxW={isProduct ? { base: "100%", sm: "62.5%" } : { base: "calc(100% - 40px)", sm: "calc(100% - 30px)" }}
      >
        <Box
          pb={isProduct ? { sm: "20px" } : "50px"}
          w="100%"
          maxW={isProduct || isSkinSupport ? "100%" : { sm: "60%" }}
          sx={{
            p: {
              fontSize: isProduct ? { base: 18, sm: 20 } : 16,
              lineHeight: { base: 1.4, sm: 1.5 },
            },
          }}
        >
          {resolvedContent}
        </Box>
      </Flex>
    </AccordionPanel>
  )
}

export default React.memo(AccordionGroupItem)
